<template>
  <i style="display: none !important;">
    <template v-for="(child, index) in children">
      <VWmsSublayer
        :key="`wms-sublayer-${index}-${child[propertiesKey]}`"
        :properties="child"
        :properties-children="propertiesChildren"
        :properties-key="propertiesKey"
        :returnObject="returnObject"
        :visible-value="visibleValue"
        @input="$emit('input', $event)"
      />
    </template>
  </i>
</template>

<script>
import layerTree from '../../mixins/layer-tree';
import VWmsSublayer from '../VWmsSublayer';

import _has from "lodash/has";
import _omit from 'lodash/omit';

import {loadModules} from 'esri-loader';

export default {
  mixins: [layerTree],
  provide () {
    return {
      getLayers: this.getSublayers
    };
  },
  components: {
    VWmsSublayer
  },
  methods: {
    /**
     * @Override
     */
    async loadEsriModules () {
      return await loadModules(['esri/layers/WMSLayer']);
    },
    /**
     * @Override
     * @returns {Promise<WMSLayer>}
     */
    async createEsriObject () {
      const [WMSLayer] = this.$esriModules;
      const layer = new WMSLayer({
        ..._omit(this.properties, 'sublayers'),
        visible: this.visible
      });
      if (this.hasChildren) {
        layer.sublayers = [];
      }
      if (_has(this.properties, 'visible') && this.properties.visible !== this.visible) {
        this.$nextTick(() => {
          this.setVisible(this.properties.visible);
        });
      }

      return layer;
    },
    getSublayers () {
      return this.$esriObject ? this.$esriObject.sublayers : null;
    }
  }
};
</script>
